import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectShowRedirectScreen } from '../../state/pageState/page-state.selectors';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-redirect-screen',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './redirect-screen.component.html',
})
export class RedirectScreenComponent {
  store: Store = inject(Store);
  showRedirectScreen$: Observable<boolean> = this.store.select(selectShowRedirectScreen);

}
